module.exports = __webpack_public_path__ + "static/media/icon_pulldown_b.f29f1354.svg";